import * as React from "react";
import Button from "components/common/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const FaqCategoryDeleteModel = ({ open, handleDeleteCloseModel,handleDelete }) => {
    return (
        <div>
          <Dialog
            open={open}
             onClose={handleDeleteCloseModel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" sx={{ fontSize: "15px" }}>
              {"Are you sure you want to Delete this detail?"}
            </DialogTitle>
            <DialogContent></DialogContent>
            <DialogActions
              sx={{
                justifyContent: "space-around",
              }}
            >
              <Button sx={{ fontSize: "15px" }}
              
              onClick={() => handleDelete()}
              >Delete</Button>
              <Button
                onClick={() => handleDeleteCloseModel()}
                sx={{ backgroundColor: "red", color: "white", fontSize: "15px" }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
};

export default FaqCategoryDeleteModel;
